<div class="chips">
  Legend:
  <mat-chip-list>
    <mat-chip class="include" matTooltip="Green filters indicate that the saved selections will be included in the search result." matTooltipPosition="above">Inclusive</mat-chip>
    <mat-chip class="exclude" matTooltip="Red filters indicate that the saved selections will be excluded from the search result." matTooltipPosition="above">Exclusive</mat-chip>
    <mat-chip class="not-allowed" matTooltip="Grey filters indicate that the saved selection will not be used in the search result." matTooltipPosition="above">Not Allowed</mat-chip>
  </mat-chip-list>
</div>
